import { IVehicleDetails } from './vehicle-output-dto.interface';
import { DeviceTypeEnum, ExternalVehicleAllowedActions } from '../enums';

export interface IDeviceInputDto {
    type: DeviceTypeEnum;
    trackerType?: string;
    code: string;
    lastReportDate?: string;
}

export interface IVehicleExternalOrganizationsInputDto {
    organizationId: string;
    allowedActions?: ExternalVehicleAllowedActions[];
}

export interface ICreateVehicleInputDto {
    organizationId?: string;
    externalId?: string | null;
    name: string;
    type: string;
    code?: string;
    licensePlate: string;
    device?: IDeviceInputDto;
    carrierId: string;
    details?: IVehicleDetails;
    tags?: string[];
    status?: string;
    externalOrganizations?: IVehicleExternalOrganizationsInputDto[];
    semitrailerIds?: string[];
}

export interface IUpdateVehicleInputDto extends Partial<Omit<ICreateVehicleInputDto, 'device'>> {
    id?: string;
    // Partial: an update may touch just device.lastReportDate, so `type`/`code` aren't required.
    device?: Partial<IDeviceInputDto>;
    blocked?: boolean;
}

export interface IBulkUpdateVehiclesInputDto {
    vehicles: IUpdateVehicleInputDto[];
}
